import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Papa from 'papaparse';

// Async thunk to fetch fire data from NASA CSV API and parse it
export const fetchFires = createAsyncThunk(
'map/fetchFires',
async (args, thunkAPI) => {
try {
const state = thunkAPI.getState();
const filters = args && Object.keys(args).length ? args : state.map.filters;

  const { source = 'VIIRS_SNPP_NRT', area = 'world', days = 2 } = filters;
  const mapKey = '627b88d4a42189d0c1f1a6c112078ec1';
  const url = `https://firms.modaps.eosdis.nasa.gov/api/area/csv/${mapKey}/${source}/${area}/${days}`;

  const response = await fetch(url);
  const csvText = await response.text();

  return new Promise((resolve, reject) => {
    Papa.parse(csvText, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: (results) => {
        const filtered = results.data
          .filter((row) => row.latitude && row.longitude)
          .slice(0, 200); // Only top 100 records
        resolve(filtered);
      },
      error: (err) => reject(err),
    });
  });
} catch (error) {
  return thunkAPI.rejectWithValue(error.message || 'Failed to load fire data');
}
}
);

const mapSlice = createSlice({
  name: 'map',
  initialState: {
    fires: [],
    loading: false,
    error: null,
    filters: {
      source: 'VIIRS_SNPP_NRT',
      area: 'world',
      days: 2, // Default to last 48 hours
    },
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFires.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFires.fulfilled, (state, action) => {
        state.fires = action.payload;
        state.loading = false;
      })
      .addCase(fetchFires.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setFilters } = mapSlice.actions;
export default mapSlice.reducer;
